// extracted by mini-css-extract-plugin
module.exports = {"mytd":"style_mytd__2M1fN"};